import React,{useState,}from 'react'
import { Modal} from 'antd';
import ArapDesc from './ArapDesc';
function ArapCheck(props) {   
    const [open,setOpen] = useState(false);
    return (
        <>
            <a onClick={() => {setOpen(true)}}>
                {props.titleType==='数字' ? props.eie_hx_number : '查看'}
            </a>
            <Modal                 
                open={open} 
                onOk={() => {setOpen(true)}} 
                onCancel={() => {setOpen(false)}} 
                okText='关闭' 
                width={1280}
                footer={null}
            >
               <ArapDesc 
                    eie_hx_number = {props.eie_hx_number}
                    open={open}
               />    
            </Modal>
        </>
    )
}

export default ArapCheck